import { boolean, object, ref, string } from 'yup';

export const signUpSchema = object({
	full_name: string()
		.trim()
		.required('SignUpValidationId1')
		.matches(/^[\p{L}\s'-]{2,50}$/u, {
			message: 'SignUpValidationId2',
			excludeEmptyString: true,
		}),
	email: string()
		.trim()
		.required('SignUpValidationId3')
		.matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, {
			message: 'SignUpValidationId4',
			excludeEmptyString: true,
		}),
	password: string()
		.required('SignUpValidationId6')
		.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,128}$/, {
			message: 'SignUpValidationId7',
			excludeEmptyString: true,
		}),
	confirmPassword: string()
		.required('SignUpValidationId8')
		.oneOf([ref('password')], 'SignUpValidationId9'),
	agreeToTerms: boolean().oneOf([true], 'SignUpValidationId10'),
});
